import { message } from "antd";
import { NavigateFunction } from "react-router-dom";
import { AppDispatch } from "../../../../../../redux/store";
import { createBooking, getBookingDetail, setBookingForm, setFormState, updateBooking } from "../../../ducks/actions";

type BookingDetailsLike = {
  tenantDetails?: { tenantIdentityType?: string };
};

type HandleBookingOptions = {
  formData: Record<string, unknown>;
  bookingDetails?: BookingDetailsLike;
  isBooking: boolean;
  leaseId: string;
  usageType: string;
  dispatch: AppDispatch;
  parentState: (object: unknown) => void;
  navigate: NavigateFunction;
};

export const handleBooking = async (options: HandleBookingOptions) => {
  const { formData, bookingDetails, isBooking, leaseId, dispatch, parentState, navigate } = options;

  const tenantIdentityType =
    formData.tenantIdentityType ?? bookingDetails?.tenantDetails?.tenantIdentityType;

  const payload = {
    ...formData,
    ...(tenantIdentityType ? { tenantIdentityType } : {}),
  };

  parentState({ load: true });

  try {
    if (isBooking) {
      dispatch(setBookingForm(payload));
    }

    const response = await dispatch(!isBooking ? createBooking(payload) : updateBooking({ leaseId, body: payload }));

    if (!isBooking) {
      await dispatch(getBookingDetail(response.data?.result));
      navigate(`/newbookingform/${response.data?.result}`, { replace: true });
    } else {
      await dispatch(getBookingDetail(leaseId || response.data?.result));
    }

    message.success(response.data.message);
  } catch (error: any) {
    message.error(error.response?.data?.error || error.response?.data?.message);
  } finally {
    parentState({ load: false });
    dispatch(setFormState());
  }
};
